import { render, staticRenderFns } from "./PriceMargins.vue?vue&type=template&id=19a41f97&scoped=true&"
import script from "./PriceMargins.vue?vue&type=script&lang=js&"
export * from "./PriceMargins.vue?vue&type=script&lang=js&"
import style0 from "./PriceMargins.vue?vue&type=style&index=0&id=19a41f97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a41f97",
  null
  
)

export default component.exports